import React from 'react';
import { PencilIcon, TrashIcon } from '@revfluence/fresh-icons/solid/esm';
import { snakeToInitCap } from '@frontend/applications/AffiliatesApp/utils';
import AdvancedSelectionCardForm from './AdvancedSelectionCardForm';
import { Condition, ConditionOption } from './BoostTypes';

interface AdvancedSelectionConditionProps {
  mode: 'display' | 'edit' | 'add';
  condition: Condition | null;
  index: number | null;
  onEdit: () => void;
  onDelete: () => void;
  onSave: (index: number | null, condition: Condition) => void;
  onCancel: () => void;
  conditionOptions: ConditionOption[];
}

const AdvancedSelectionCondition: React.FC<AdvancedSelectionConditionProps> = ({
  mode,
  condition,
  index,
  onEdit,
  onDelete,
  onSave,
  onCancel,
  conditionOptions,
}) => {
  if (mode === 'edit' || mode === 'add') {
    return (
      <AdvancedSelectionCardForm
        initialCondition={mode === 'edit' ? condition : null}
        index={index}
        onSave={onSave}
        onCancel={onCancel}
        conditionOptions={conditionOptions}
        mode={mode}
        onDelete={onDelete}
      />
    );
  }
  // display mode
  if (!condition) return null;
  return (
    <div className="bg-grey-0 border border-grey-2 rounded-xl p-4 mb-2 flex flex-row items-center gap-2 shadow-sm">
      <div className="flex-1 text-sm text-gray-800">
        <span className="font-medium text-gray-600">{conditionOptions.find((opt) => opt.id === condition.attribute)?.displayName || '—'}</span>
        {' '}
        <span className="text-gray-500">{snakeToInitCap(condition.op)}</span>
        {' '}
        <span className="text-gray-800">{String(condition.value)}</span>
      </div>
      <button onClick={onEdit}><PencilIcon /></button>
      <button onClick={onDelete}><TrashIcon /></button>
    </div>
  );
};

export default AdvancedSelectionCondition;
